import React, { useEffect, useState, useCallback } from 'react'

export const useCountdown = (month = 9, day = 24, year = 2020) => {
  const calculateTimeLeft = useCallback(() => {
    const countdownTo = new Date()

    countdownTo.setFullYear(year)
    countdownTo.setMonth(month - 1)
    countdownTo.setDate(day)
    countdownTo.setHours(0)

    const difference = countdownTo.getTime() - Date.now()

    let timeLeft = {}

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      }
    }

    return timeLeft
  }, [month, day, year])

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)
  }, [calculateTimeLeft])

  const timerComponents = []

  Object.keys(timeLeft).forEach(interval => {
    if (!timeLeft[interval]) {
      return
    }

    timerComponents.push(
      <span>
        {timeLeft[interval]} {interval}{' '}
      </span>
    )
  })
  return { timeLeft, timerComponents }
}
